import React from 'react';
import PropTypes from 'prop-types';

const Picture = ({
  content, defaultImage, alt = '', className, lazy,
}) => (
  <picture>
    { content && content.map((item, index) => (
      <source
        media={item.media}
        srcSet={item.image}
        key={index}
      />
    )) }
    <img src={defaultImage} alt={alt} className={className} loading={lazy ? 'lazy' : undefined} />
  </picture>
);

Picture.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      media: PropTypes.string,
    }),
  ),
  defaultImage: PropTypes.string.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
  lazy: PropTypes.bool,
};

export default Picture;
